// tslint:disable trailing-comma

import Auth from '@/features/auth/View.vue';

export default [
  {
    path: '/auth',
    name: 'auth',
    component: Auth,
  },
  {
    path: '/',
    name: 'home',
    component: () => import(
      /* webpackChunkName: "home" */
      '@/features/home/View.vue'
    ),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(
      /* webpackChunkName: "dashboard" */
      '@/features/dashboard/View.vue'
    ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/linesheets',
    name: 'linesheets',
    component: () => import(
      /* webpackChunkName: "linesheets" */
      '@/features/linesheet/views/linesheets/Component.vue'
    ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/linesheets/:linesheetId',
    name: 'linesheet',
    component: () => import(
      /* webpackChunkName: "linesheet" */
      '@/features/linesheet/views/linesheet/Component.vue'
    ),
  },
  {
    path: '/products',
    name: 'products',
    component: () => import(
      /* webpackChunkName: "products" */
      '@/features/product/views/products/Component.vue'
    ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/products/:productId',
    name: 'product',
    component: () => import(
      /* webpackChunkName: "product" */
      '@/features/product/views/product/Component.vue'
    ),
  },
  {
    path: '/materials',
    name: 'materials',
    component: () => import(
      /* webpackChunkName: "materials" */
      '@/features/material/views/materials/Component.vue'
    ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/materials/:materialId',
    name: 'material',
    component: () => import(
      /* webpackChunkName: "material" */
      '@/features/material/views/material/Component.vue'
    ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/components',
    name: 'components',
    component: () => import(
      /* webpackChunkName: "components" */
      '@/features/component/views/components/Component.vue'
    ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/components/:componentId',
    name: 'component',
    component: () => import(
      /* webpackChunkName: "component" */
      '@/features/component/views/component/Component.vue'
    ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/vendors',
    name: 'vendors',
    component: () => import(
      /* webpackChunkName: "vendors" */
      '@/features/vendor/views/vendors/Component.vue'
    ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/vendors/:vendorId',
    name: 'vendor',
    component: () => import(
      /* webpackChunkName: "vendor" */
      '@/features/vendor/views/vendor/Component.vue'
    ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/batches',
    name: 'batches',
    component: () => import(
      /* webpackChunkName: "batches" */
      '@/features/batch/Component.vue'
    ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '*',
    component: () => import(
      /* webpackChunkName: "404" */
      '@/features/404/View.vue'
    ),
  },
];

